import apiClient from "../helper/Axios/axiosHelper";
import logger from "../../src/utils/logger"

export class AuthenticationService {

    static async login(data) {

        // logger.debug('data recida: ', data)

        let response = await apiClient.post("Authentication/Login", data);

        
        logger.debug('data recida: ', response)
        

        return response.data;
    }

    static async refreshToken(){
        let data = { refreshToken: localStorage.getItem('refresh-token') };

        let response = await apiClient.post("Authentication/refreshToken", data);

        return response.data;
    }

    static async forgotPassword(data){
        let response = await apiClient.post("Authentication/forgotPassword", data);

        return response.data;
    }


    static async logout(){

        let data = { refreshToken: localStorage.getItem('refresh-token') };
        
        let response = await apiClient.post("Authentication/logout", data);


    
        return response;
    }


    static async me(){
        let response = await apiClient.get("Authentication/Me");
    
        logger.warn('ME: ',response)
    }
}





